import Dexie from 'dexie';
import moment from 'moment';
import DASHBOARD from '../dashboard';

DASHBOARD.namespace('DASHBOARD.Services');

DASHBOARD.Services.OfflineGetService = (function offline() {

    const HOURS = 2;
    const MAX_CACHE_ITEMS = 256;

    /**
     * public API -- constructor
     */
    const fnConstructor = function fn() {
        // setup storage with the requested name
        this.storage = new Dexie('nedglobe.datastore.get');
        this.storage.version(1).stores({
            // autoincrement id
            // index key
            requests: '++id, key',
        });
    };

    /**
     * public API -- prototype
     * @type {Object}
     */
    fnConstructor.prototype = {
        constructor: DASHBOARD.Services.OfflineGetService,
        version: '1.0',

        /**
         * Get data from the datastore for the given key
         * @param {string} key, entry key of the data
         */
        getData(key) {
            return new Promise((resolve, reject) => {
                try {
                    // is there a previous value?
                    this.storage.requests.where({ key: key, }).first().then((value) => {
                        resolve({
                            data: JSON.parse(value.data),
                            expires: value.expires,
                        });
                    }).catch((e) => {
                        resolve(null);
                    });
                } catch (e) {
                    reject(e.message);
                }
            });
        },

        /**
         * Set data on the datastore
         * @param {string} name, key of the entry
         * @param {string} data of the entry
         */
        setData(key, jsonData) {
            return new Promise((resolve, reject) => {
                // check for current data
                this.getData(key).then((oldValue) => {
                    this.storage.transaction('rw', this.storage.requests, async () => {
                        const expiresAt = moment().add(HOURS, 'hours');
                        // update or add new value
                        if (oldValue) {
                            // update existing item in the cache
                            await this.storage.requests.update(key, { data: jsonData, expires: expiresAt.toJSON() }).then(() => {
                                resolve();
                            });
                        } else {
                            // check num items
                            this.storage.requests.count().then(async (count) => {
                                if (count > MAX_CACHE_ITEMS) {
                                    // what is the performance of toCollection() for many entires?
                                    this.storage.requests.toCollection().first().then((entry) => {
                                        this.storage.requests.delete(entry.id).then(async () => {
                                            // add new item to the cache
                                            await this.storage.requests.add({ key: key, data: jsonData, expires: expiresAt.toJSON() }).then(() => {
                                                resolve();
                                            });
                                        });
                                    });
                                } else {
                                    // add new item to the cache
                                    await this.storage.requests.add({ key: key, data: jsonData, expires: expiresAt.toJSON() }).then(() => {
                                        resolve();
                                    });
                                }
                            });
                        }
                    }).then(() => {
                        //transaction end
                    }).catch((error) => {
                        reject(error);
                    });
                }).catch((error) => {
                    reject(error);
                });
            });
        },

        /**
         * Delete an entry from the store
         * @param {string} name, key of the entry
         */
        delData(key) {
            return new Promise((resolve, reject) => {
                this.storage.requests.delete(key).then(() => {
                    resolve(true);
                }).catch((e) => {
                    reject(e.message);
                });
            });
        },

        /**
         * Get the keys of all entries in the store
         * @return {promise} keys promise
         */
        getAllKeys() {
            return new Promise((resolve, reject) => {
                try {
                    this.storage.requests.orderBy('key').keys().then((keys) => {
                        resolve(keys);
                    });
                } catch (e) {
                    reject(e.message);
                }
            });
        },

    };

    // return the constructor
    return fnConstructor;
}());

export default DASHBOARD.Services.OfflineGetService;
